<template>
  <div class="mt-2 form-responsive material-form">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="materiallistReference">
      <template slot="use_consumable">
        <div class="d-flex align-center">
          <v-checkbox hide-details="auto" color="primary" v-model="modelObj.use_consumable" :label="$t('message.projectFeature.weldingConsumable')"></v-checkbox>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon class="ml-1" small v-on="on">mdi-information-outline</v-icon>
            </template>
            <span>{{ $t('message.projectFeature.registerBatchAgainstWps') }}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-if="modelObj.id && listOfDocuments.length > 0" slot="materiallist_documents">
        <documents :documents="listOfDocuments" :deleteIds="deleteDocumentIds"></documents>
      </template>
       <template slot="warehouse_product_batchno">
        <div class="custom_border">
          <v-row class="mx-0">
            <v-col class="pa-0" cols="12">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" width="50%">{{$t('message.projectFeature.productNumber')}}</th>
                      <th class="text-left" width="50%">{{$t('message.projectFeature.batchNr')}}</th>
                    </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row class="mx-0" v-for="(productBatch, index) in warehouseProductBatches" :key="index">
            <v-col sm="6" class="pa-1">
              <v-autocomplete @change="getBatchByMaterials(index, +productBatch.product_id)" :items="listOfProducts" v-model="productBatch.product_id" :item-text="(val) => `${val.product_full_name || ''}`" item-value="product_id" hide-details outlined label="Material" dense :rules="[]"></v-autocomplete>
            </v-col>
            <v-col sm="6" class="pa-1">
              <v-autocomplete :loading="productBatch.batchLoading" :disabled="productBatch.listOfBatches.length < 1" :items="productBatch.listOfBatches" v-model="productBatch.batch_no" item-text="name" item-value="_id" hide-details outlined label="Batch no" dense :rules="[]"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-spacer></v-spacer>
            <v-btn class="mx-1" style="float:right;" fab x-small color="primary" @click="addNewProductBatchObj()">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn v-if="warehouseProductBatches && warehouseProductBatches.length > 1" class="mx-1" style="float:right;" fab x-small color="primary" @click="warehouseProductBatches.pop()">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-row>
        </div>
      </template>
    </form-data>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { hostAppApi } from '@/plugins/axios_settings'
import PermissionsMixin from '@/mixins/permissions'
import FeaturesMixin from '@/mixins/features_list'

export default {
  mixins: [PermissionsMixin, FeaturesMixin],
  data () {
    return {
      listOfProjects: [],
      modelObj: {},
      loading: false,
      projectId: parseInt(this.$route.params.project_id) || 0,
      fieldsLoading: false,
      hostUserId: this.$cookie.get(process.env.VUE_APP_HOST_USER) ? this.$cookie.get(process.env.VUE_APP_HOST_USER) : 0,
      backUrl: '',
      listOfDocuments: [],
      deleteDocumentIds: [],
      hideDetails: true,
      listOfDrawings: [],
      listOfprojectwps: [],
      currentUserSign: '',
      warehouseEnabled: false,
      warehouseProductBatches: [],
      listOfProducts: [],
      productBatchesObj: {}
    }
  },
  computed: {
    ...mapGetters(['formType', 'generalSettings', 'userDetails', 'getHostRefApi', 'userId']),
    ...mapGetters('project', ['project']),
    formReferences () {
      /* One place to change a column width, instead of 13 copies of the same string.
         phone (xs) / tablet portrait (sm) / tablet landscape (md) / desktop (lg) */
      const col = {
        heading: 'xs12',
        code: 'xs12 sm6 md4 lg3', // short identification codes
        wide: 'xs12', // description, warehouse table
        qty: 'xs6 sm4 md3 lg2', // numeric quantities
        toggle: 'xs12 sm6 md4 lg3 toggle-col',
        files: 'xs12 sm12 md8 lg6'
      }
      const isNew = !this.modelObj.id
      const consumable = this.modelObj.use_consumable
      const warehouse = this.warehouseEnabled

      return {
        cardFlat: true,
        cardTitleClass: 'pa-1',
        layoutClass: 'pa-1',
        title: isNew ? this.$t('message.common.addNew') : this.$t('message.common.update'),
        properties: [
          /* ---------------- Identification ---------------- */
          {
            type: 'section',
            label: this.$t('message.projectFeature.sectionIdentification'),
            class: col.heading
          }, {
            model: 'po_ranked',
            type: this.formType.TEXT,
            readonly: true,
            label: this.$t('message.projectFeature.poRanked'),
            class: col.code
          }, {
            model: 'teg_nr',
            type: this.formType.COMBOBOX,
            items: this.listOfDrawings,
            rules: this.$_requiredValidation,
            multiple: false,
            label: this.$t('message.projectFeature.tegNr'),
            class: col.code,
            is_show: !consumable
          }, {
            model: 'pos_nr',
            type: this.formType.TEXT,
            rules: this.$_requiredValidation,
            label: this.$t('message.projectFeature.posNr'),
            class: col.code,
            is_show: !consumable
          }, {
            model: 'wps_nr',
            type: this.formType.SELECT,
            rules: consumable ? this.$_requiredValidation : [],
            items: this.listOfprojectwps,
            select_text: 'name',
            select_value: 'id',
            label: this.$t('message.projectFeature.wpsNumber'),
            class: col.code,
            is_show: consumable
          }, {
            model: 'batch_nr',
            type: this.formType.TEXT,
            rules: [],
            label: this.$t('message.projectFeature.batchNr'),
            class: col.code,
            is_show: !warehouse
          }, {
            model: 'heat_nr',
            type: this.formType.TEXT,
            rules: [],
            label: this.$t('message.projectFeature.heatNr'),
            class: col.code,
            is_show: !warehouse
          }, {
            model: 'list_date',
            type: this.formType.DATEPICKER,
            rules: [],
            placeholder: this.$formatter.formatDate(new Date(), undefined, 'DD.MM.YYYY'),
            picker: 'createdOnDatePicker',
            menu: 'createdOnDateMenu',
            color: 'primary lighten-1',
            label: this.$t('message.common.date'),
            class: col.code
          }, {
            type: 'warehouse_product_batchno',
            slot: 'warehouse_product_batchno',
            class: col.wide,
            is_show: warehouse
          },

          /* ---------------- Description ---------------- */
          {
            type: 'section',
            label: this.$t('message.deviation.description'),
            class: col.heading
          }, {
            model: 'description',
            type: this.formType.TEXTAREA,
            rules: [],
            label: this.$t('message.projectFeature.descriptionHint'),
            class: col.wide,
            rows: 2,
            autoGrow: true
          },

          /* ---------------- Stock ---------------- */
          {
            type: 'section',
            label: this.$t('message.projectFeature.sectionStock'),
            class: col.heading,
            is_show: !warehouse
          }, {
            model: 'on_stock',
            type: this.formType.NUMBER,
            rules: [],
            label: this.$t('message.projectFeature.onStock'),
            class: col.qty,
            is_show: !warehouse
          }, {
            model: 'out',
            type: this.formType.NUMBER,
            rules: [],
            label: this.$t('message.projectFeature.out'),
            class: col.qty,
            is_show: !warehouse
          },

          /* ---------------- Status & attachments ---------------- */
          {
            type: 'section',
            label: this.$t('message.projectFeature.sectionStatus'),
            class: col.heading
          }, {
            model: 'is_completed',
            rules: [],
            type: this.formType.CHECKBOX,
            class: col.toggle,
            label: this.$t('message.customModule.isCompleted')
          }, {
            type: 'use_consumable',
            slot: 'use_consumable',
            class: col.toggle
          }, {
            model: 'files',
            type: this.formType.FILES,
            multiple: true,
            rules: this.$_maxFileSizeValidation(100, this.modelObj.files),
            label: this.$t('message.projectFeature.selectFiles'),
            class: col.files,
            slot: 'materiallist_documents'
          }
        ],
        buttons: [{
          name: 'save_materiallist',
          color: 'primary',
          label: isNew ? this.$t('message.common.save') : this.$t('message.common.update'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'back',
          color: 'info',
          click: () => this.$router.go(-1),
          label: this.$t('message.login.back'),
          to: this.backUrl,
          is_show: true
        }]
      }
    }
  },
  mounted () {
    // set back url
    this.backUrl = this.projectId ? `/projects/${this.projectId}/material-list` : '/material-list'
    this.initializeFormData()
    this.getFormDropdownValues() // / create method call
  },
  components: {
    'form-data': () => import('@/components/FormTemplate'),
    documents: () => import('@/components/Documents/Documents')
  },
  methods: {
    initializeFormData () {
      if (!this.project) return
      this.fieldsLoading = true
      this.modelObj = {
        po_ranked: this.project.number,
        project_id: this.projectId,
        use_consumable: false,
        list_date: this.$formatter.formatDate(new Date(), undefined, 'DD.MM.YYYY')
      }
      if (this.$route.params.id) {
        this.initializeEditData(this.$route.params.id)
        return
      }
      this.fieldsLoading = false
    },
    getFormDropdownValues () {
      hostAppApi.get(`${this.getHostRefApi}project_materiallist/create?user_id=${this.hostUserId}&project_id=${this.projectId}`)
        .then((response) => {
          if (response.data) {
            const { drawings, projectwps, currentusersign, project } = response.data
            if (project && project.project_config && project.project_config.warehouse) {
              const warehouseForProject = project.project_config.warehouse
              if (warehouseForProject.active) {
                /* check if has warehouse feature then do changes as #10063 */
                this.warehouseEnabled = true
                this.getMaterials()
              } else this.warehouseEnabled = false
            }
            var drawingList = []
            if (Object.keys(drawings).length) {
              Object.keys(drawings).forEach(key => {
                drawingList.push(drawings[key])
              })
            }
            this.currentUserSign = currentusersign || ''
            this.listOfDrawings = drawingList || []
            /* projectwps comes as a { value: label } map (incl. an empty placeholder) -> convert to array of { name, id } */
            const wpsList = []
            if (projectwps) {
              Object.keys(projectwps).forEach(key => {
                if (key !== '') wpsList.push({ id: key, name: projectwps[key] })
              })
            }
            this.listOfprojectwps = wpsList
          }
        })
        .finally(() => {})
    },
    saveUpdateHandler () {
      if (this.$refs.materiallistReference.$refs.validateForm.validate()) {
        this.loading = true
        const files = this.modelObj.files
        const model = this.$formatter.cloneVariable(this.modelObj)
        model.user_id = parseInt(this.hostUserId)
        const formData = new FormData()
        if (files) {
          const Newfile = [...files]
          Newfile.forEach((file, i) => {
            formData.append('document[' + i + ']', file)
          })
        }
        const newobj = this.$formatter.removeInvalidFromObject(model)
        newobj.product_id = []
        newobj.batch_no = []
        this.warehouseProductBatches.forEach((productBatchObj) => {
          newobj.product_id.push(productBatchObj.product_id || 0)
          newobj.batch_no.push(productBatchObj.batch_no || '')
        })
        newobj.product_id = newobj.product_id.join('$$$')
        newobj.batch_no = newobj.batch_no.join('$$$')
        if (newobj.teg_nr) {
          var as = newobj.teg_nr.split('(')
          newobj.teg_nr = as[0].trim()
        }
        /* if user cleared the date, default to today's date in payload */
        if (!newobj.list_date) newobj.list_date = this.$formatter.formatDate(new Date(), undefined, 'DD.MM.YYYY')
        setTimeout(() => {
          for (const key in newobj) {
            if (key === 'files') continue
            /* booleans must be sent as 1/0 so Laravel's boolean rule accepts them (FormData would turn true/false into the strings "true"/"false") */
            if (key === 'is_completed' || key === 'use_consumable') formData.append(key, newobj[key] ? 1 : 0)
            else formData.append(key, newobj[key] || null)
          }
          const header = {
            'Content-Type': 'multipart/form-data'
          }
          let url = this.getHostRefApi
          // const method = model.id ? 'put' : 'post'
          url += model.id ? `project_materiallist/${model.id}/update` : 'project_materiallist'
          const text = model.id ? 'message.common.updatedSuccess' : 'message.common.addedSucess'
          /* on update check if there is documents in array to delete */
          const ids = [...this.deleteDocumentIds]
          if (model.id && ids.length > 0) formData.append('document_delete_ids', ids)
          hostAppApi.post(url, formData, { headers: header }) // `${url}?locale=${this.$i18n.locale}`
            .then((response) => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
              this.$router.push(this.backUrl)
            })
            // .catch(error => {
            //   if (error.response) {
            //     let exception = error.response
            //     if (error.response.data) exception = `Status Code : ${error.response.status}, Message : ${error.response.data}`
            //     else exception = `Status Code : ${error.response.status}, Message : ${error.response.statusText}`
            //     this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(exception), isException: true })
            //     if (error.response.status === 401) {
            //       this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.authFailed' })
            //       this.$store.dispatch('logout')
            //       this.$router.push('/login').catch(() => {})
            //     }
            //   } else {
            //     this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(error.message), isException: true })
            //   }
            // })
            .finally(() => {
              this.loading = false
            })
        }, 50)
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
    },
    initializeEditData (id) {
      this.fieldsLoading = true
      hostAppApi.get(`${this.getHostRefApi}project_materiallist/${id}/edit?user_id=${this.hostUserId}&project_id=${this.projectId}`)
        .then((response) => {
          if (response.data) {
            // it has more object get materiallist object from them
            /* eslint-disable camelcase */
            let { materiallist, materiallist_documents, drawings, material_products } = this.$formatter.cloneVariable(response.data)
            var drawingList = []
            if (Object.keys(drawings).length) {
              Object.keys(drawings).forEach(key => {
                drawingList.push(drawings[key])
              })
            }
            const transformData = { date: { list: ['list_date'], from: 'YYYY-MM-DD HH:mm:ss', to: 'DD.MM.YYYY' } }
            const model = this.$formatter.formatModel(materiallist, transformData)
            this.modelObj = {
              ...this.modelObj,
              ...model
            }
            this.listOfDocuments = this.$formatter.removeInvalidFromArrayObject(materiallist_documents)
            drawingList.forEach((val, index) => {
              var value = val.split('(')
              if (value[0].trim() === materiallist.teg_nr) {
                this.modelObj.teg_nr = drawingList[index]
              }
            })
            /* set material Products */
            material_products = material_products || []
            material_products.forEach(product => {
              const obj = { product_id: product.product_id, batch_no: product.batch_no, listOfBatches: product.batches, batchLoading: false }
              this.warehouseProductBatches.push(obj)
            })
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    getMaterials () {
      hostAppApi.get(`${this.getHostRefApi}get_weldlog_materials?user_id=${this.userId}&project_id=${this.modelObj.project_id}`)
        .then((response) => {
          if (response.data) {
            this.listOfProducts = response.data || []
            if (!this.$route.params.id && this.warehouseProductBatches && this.warehouseProductBatches.length < 1) this.addNewProductBatchObj()
          }
        })
    },
    getBatchByMaterials (index, productId) {
      this.warehouseProductBatches[index].batchLoading = true
      hostAppApi.get(`${this.getHostRefApi}get_batch_by_material/${productId}?user_id=${this.hostUserId}&project_id=${this.modelObj.project_id}`)
        .then((response) => {
          if (response.data) {
            const sameProductsExisting = this.warehouseProductBatches.filter(x => x.product_id === productId)
            const batchNos = sameProductsExisting.map(x => x.batch_no)
            this.warehouseProductBatches[index].listOfBatches = response.data.filter(x => !batchNos.includes(x))
          }
        })
        .finally(() => {
          this.warehouseProductBatches[index].batchLoading = false
        })
    },
    addNewProductBatchObj () {
      this.warehouseProductBatches.push({ product_id: 0, batch_no: '', listOfBatches: [], batchLoading: false })
    }
  },
  watch: {
    isShowDocumentErrors (val) {
      this.hideDetails = !val
    }
  }
}
</script>

<style scoped>
/* Layout rules (toggle baseline, sticky actions, 48px tablet inputs) come from
   the shared .form-responsive block in src/assets/css/app.scss. Only the
   material-specific rule stays here. */

/* The warehouse product/batch box borrowed .custom_border from an unscoped
   block in WeldLog/Actions.vue, so the border only appeared if the user had
   opened the Weld Log form earlier in the session. Own it here. */
.material-form ::v-deep .custom_border {
  border: 1px solid rgba(128, 128, 128, 0.45);
  border-radius: 4px;
  padding: 4px;
}
</style>
